(function () {
  // Pinned Chart.js build for supply-chain integrity.
  var CHART_JS_VERSION = "4.4.9";
  var CHART_JS_URL =
    "https://cdn.jsdelivr.net/npm/chart.js@" +
    CHART_JS_VERSION +
    "/dist/chart.umd.min.js";
  var CHART_JS_SRI =
    "sha384-b0GXujLkk9eYYSmcSfoyZbfyElGAQnDyY0skCHSG6w3JgTMFnz11ggrTAr7seu9f";

  // Used when Shopify app proxy is not yet forwarding /apps/meltonia/*.
  var RAILWAY_FALLBACK =
    "https://meltonia-automation-prod.up.railway.app/apps/meltonia/comp-calculator";

  var chartInstances =
    typeof WeakMap !== "undefined" ? new WeakMap() : null;
  var chartJsPromise = null;

  function loadChartJs() {
    if (window.Chart) {
      return Promise.resolve(window.Chart);
    }
    if (chartJsPromise) {
      return chartJsPromise;
    }

    chartJsPromise = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = CHART_JS_URL;
      script.async = true;
      script.crossOrigin = "anonymous";
      script.referrerPolicy = "no-referrer";
      if (CHART_JS_SRI) {
        script.integrity = CHART_JS_SRI;
      }
      script.onload = function () {
        if (window.Chart) {
          resolve(window.Chart);
          return;
        }
        reject(new Error("Chart.js failed to load"));
      };
      script.onerror = function () {
        reject(new Error("Chart.js failed to load"));
      };
      document.head.appendChild(script);
    });

    return chartJsPromise;
  }

  function formatCurrency(value) {
    var numeric = Number(value);
    if (Number.isNaN(numeric)) {
      return "$0.00";
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numeric);
  }

  function getSignalClass(signal) {
    var normalized = String(signal || "").toLowerCase();
    if (
      normalized.indexOf("below") !== -1 ||
      normalized.indexOf("under") !== -1
    ) {
      return "price-signal--below";
    }
    if (
      normalized.indexOf("above") !== -1 ||
      normalized.indexOf("over") !== -1
    ) {
      return "price-signal--above";
    }
    return "price-signal--at";
  }

  function showUnavailable(loadingEl, message) {
    if (!loadingEl) {
      return;
    }
    loadingEl.hidden = false;
    loadingEl.textContent = message || "Market comps unavailable";
  }

  function normalizePayload(payload) {
    var amounts = [payload.low, payload.median, payload.high];
    var validAmount = function (value) {
      return typeof value === "number" && Number.isFinite(value) && value > 0;
    };
    if (payload.contract_version !== 1 || payload.status !== "verified_sold" ||
        payload.evidence_ready !== true || payload.currency !== "USD" ||
        !Number.isInteger(payload.sample_size) || payload.sample_size < 1 ||
        !amounts.every(validAmount) || payload.low > payload.median || payload.median > payload.high ||
        !Array.isArray(payload.sources) || !payload.sources.length ||
        !payload.sources.every(function (source) {
          return source && typeof source.name === "string" && source.name.trim() &&
            Number.isInteger(source.count) && source.count > 0 && validAmount(source.median);
        })) {
      return null;
    }
    return {
      low: payload.low,
      median: payload.median,
      high: payload.high,
      price_signal: typeof payload.price_signal === "string" ? payload.price_signal : "",
      sources: payload.sources.map(function (source) {
        return { name: source.name.slice(0, 64), count: source.count, median: source.median };
      })
    };
  }

  function renderSourcesTable(tableEl, sources) {
    var body = tableEl.querySelector("tbody");
    body.innerHTML = "";

    if (!sources.length) {
      var emptyRow = document.createElement("tr");
      var emptyCell = document.createElement("td");
      emptyCell.colSpan = 3;
      emptyCell.textContent = "No source breakdown yet";
      emptyRow.appendChild(emptyCell);
      body.appendChild(emptyRow);
      return;
    }

    sources.forEach(function (source) {
      var row = document.createElement("tr");

      var nameCell = document.createElement("td");
      nameCell.textContent = source.name;
      row.appendChild(nameCell);

      var countCell = document.createElement("td");
      countCell.textContent = String(source.count);
      row.appendChild(countCell);

      var medianCell = document.createElement("td");
      medianCell.textContent = formatCurrency(source.median);
      row.appendChild(medianCell);

      body.appendChild(row);
    });
  }

  function renderChart(canvasEl, data) {
    if (chartInstances) {
      var existing = chartInstances.get(canvasEl);
      if (existing) {
        existing.destroy();
      }
    }

    var context = canvasEl.getContext("2d");
    var instance = new window.Chart(context, {
      type: "bar",
      data: {
        labels: ["Low", "Median", "High"],
        datasets: [
          {
            data: [
              Math.max(0, data.low),
              Math.max(0, data.median),
              Math.max(0, data.high)
            ],
            backgroundColor: ["#3FD4D0", "#E8B84A", "#FF4B8A"],
            borderRadius: 3,
            barThickness: 11
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: "y",
        animation: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: "rgba(0,0,0,0.9)",
            callbacks: {
              label: function (tooltipItem) {
                return formatCurrency(tooltipItem.parsed.x);
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: { color: "rgba(255,255,255,0.06)" },
            border: { display: false },
            ticks: {
              color: "rgba(255,255,255,0.45)",
              font: { size: 10 },
              maxTicksLimit: 4,
              callback: function (value) {
                return formatCurrency(value);
              }
            }
          },
          y: {
            grid: { display: false },
            border: { display: false },
            ticks: {
              color: "rgba(255,255,255,0.75)",
              font: { size: 11, weight: "600" }
            }
          }
        }
      }
    });

    if (chartInstances) {
      chartInstances.set(canvasEl, instance);
    }
  }

  function buildUrl(base, sku, productGid, sealed) {
    var join = base.indexOf("?") === -1 ? "?" : "&";
    return (
      base +
      join +
      "sku=" +
      encodeURIComponent(sku) +
      "&product_gid=" +
      encodeURIComponent(productGid) +
      "&sealed=" +
      encodeURIComponent(String(sealed))
    );
  }

  function fetchComps(primaryUrl, fallbackUrl, options) {
    return fetch(primaryUrl, options).then(function (response) {
      if (response.ok) {
        return response.json();
      }
      if (fallbackUrl && (response.status === 404 || response.status >= 500)) {
        return fetch(fallbackUrl, options).then(function (fallbackResponse) {
          if (!fallbackResponse.ok) {
            throw new Error(
              "Comp calculator request failed: " + fallbackResponse.status
            );
          }
          return fallbackResponse.json();
        });
      }
      throw new Error("Comp calculator request failed: " + response.status);
    });
  }

  function initCalculator(rootEl) {
    var sku = rootEl.getAttribute("data-sku");
    var productGid = rootEl.getAttribute("data-product-gid");
    var sealed = rootEl.getAttribute("data-sealed") === "true";
    var endpoint =
      rootEl.getAttribute("data-endpoint") || "/apps/meltonia/comp-calculator";
    var loadingEl = rootEl.querySelector(".comp-loading");
    var chartWrap = rootEl.querySelector(".comp-chart-wrap");
    var canvasEl = rootEl.querySelector("canvas");
    var signalEl = rootEl.querySelector(".price-signal");
    var sourcesWrap = rootEl.querySelector(".comp-sources-wrap");
    var tableEl = rootEl.querySelector(".comp-sources");

    if (!sku || !productGid) {
      showUnavailable(
        loadingEl,
        "Add a SKU to this product to load comps"
      );
      return;
    }

    if (!canvasEl || !signalEl || !tableEl || !chartWrap || !sourcesWrap) {
      showUnavailable(loadingEl);
      return;
    }

    var primaryUrl = buildUrl(endpoint, sku, productGid, sealed);
    var fallbackUrl =
      endpoint.indexOf("http") === 0
        ? null
        : buildUrl(RAILWAY_FALLBACK, sku, productGid, sealed);

    var FETCH_TIMEOUT_MS = 12000;
    var abortController =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    var fetchOptions = {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "omit"
    };
    var timeoutId = null;
    if (abortController) {
      fetchOptions.signal = abortController.signal;
      timeoutId = setTimeout(function () {
        abortController.abort();
      }, FETCH_TIMEOUT_MS);
    }

    fetchComps(primaryUrl, fallbackUrl, fetchOptions)
      .then(function (payload) {
        clearTimeout(timeoutId);
        var data = payload && typeof payload === "object" ? normalizePayload(payload) : null;
        if (!data) {
          rootEl.dataset.evidenceReady = "false";
          showUnavailable(loadingEl, rootEl.dataset.unavailableMessage || "Verified sold comparisons are unavailable for this card.");
          signalEl.classList.remove("is-visible");
          chartWrap.hidden = true;
          sourcesWrap.hidden = true;
          return;
        }
        return loadChartJs().then(function () {
          rootEl.dataset.evidenceReady = "true";
          renderChart(canvasEl, data);
          renderSourcesTable(tableEl, data.sources);
          signalEl.classList.remove("price-signal--below", "price-signal--at", "price-signal--above", "is-visible");
          if (data.price_signal && !/unavailable/i.test(data.price_signal)) {
            signalEl.textContent = data.price_signal;
            signalEl.classList.add(getSignalClass(data.price_signal), "is-visible");
          }
          loadingEl.hidden = true;
          chartWrap.hidden = false;
          sourcesWrap.hidden = false;
        });
      })
      .catch(function (err) {
        clearTimeout(timeoutId);
        rootEl.dataset.evidenceReady = "false";
        console.error("[comp-calculator] Failed to load pricing data:", err);
        showUnavailable(loadingEl, rootEl.dataset.unavailableMessage || "Verified sold comparisons are unavailable for this card.");
        signalEl.classList.remove("is-visible");
        chartWrap.hidden = true;
        sourcesWrap.hidden = true;
      });
  }

  function initSection(rootEl) {
    if (rootEl.dataset.compInit === "1") {
      return;
    }
    rootEl.dataset.compInit = "1";
    initCalculator(rootEl);
  }

  function boot(scope) {
    var root = scope || document;
    var calculators = root.querySelectorAll(".comp-calculator");
    Array.prototype.forEach.call(calculators, initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section) {
      return;
    }
    Array.prototype.forEach.call(
      section.querySelectorAll(".comp-calculator"),
      function (el) {
        delete el.dataset.compInit;
        initSection(el);
      }
    );
  });
})();
